var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWarningTranslucent(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 64,
    height: 64,
    fill: "none",
    viewBox: "0 0 64 64",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#EE741F",
    d: "M32 64c17.673 0 32-14.327 32-32C64 14.327 49.673 0 32 0 14.327 0 0 14.327 0 32c0 17.673 14.327 32 32 32z",
    opacity: 0.2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#EE741F",
    d: "M32.479 42.042c1.369 0 2.479 1.11 2.479 2.48 0 1.368-1.11 2.478-2.48 2.478C31.11 47 30 45.89 30 44.521s1.11-2.479 2.479-2.479zm0-25.042c1.07 0 1.951.758 2.05 1.727l.01.184v16.78c0 1.055-.922 1.91-2.06 1.91-1.071 0-1.951-.758-2.051-1.727l-.01-.184V18.911c0-1.055.923-1.911 2.06-1.911z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarningTranslucent);
export default __webpack_public_path__ + "static/media/warning-translucent.61ba19a7981305112b62c7a96b017231.svg";
export { ForwardRef as ReactComponent };